import { ReportSummary_Trackable as Slot } from 'models';
import {
  DELETE_SLOT,
  REVERT_SLOT,
  SET_GROUP_COLUMN,
  SET_GROUP_ORDER,
  SET_SLOT_NAME,
  SET_SUMMARY_COLUMN,
  SET_SUMMARY_ORDER
} from 'views/DashboardSettings_Slot/flow/actionTypes';
import {
  COMMIT_DATA,
  REVERT_SLOTS,
  SET_DASHBOARD_NAME,
  SET_DETAILS,
  RESET_DETAILS,
  ADD_REPORT_TO_ZONE,
  ADD_SLOT_TO_ZONE,
  SWAP_SLOT_WITH_REPORT,
  SWAP_SLOT_WITH_SLOT
} from './actionTypes';

// Utils
// temp solution
const batchUpdateSlotsPositions = (slots, zoneIndex) => {
  const filteredSlots = slots.filter(s => s.position.x === zoneIndex);

  const sortedSlots = _.sortBy(filteredSlots, ['position.y']);

  return sortedSlots.map((s, i) => {
    s.position.y = i;
    return s;
  });
};
const sortSlotsByPosition = slots => {
  return [
    ...batchUpdateSlotsPositions(slots, 0),
    ...batchUpdateSlotsPositions(slots, 1)
  ];
};

const initialState = {
  slots: [],
  title: ''
};

let slot = null;
let dropIndex = 0;

const details = (state = initialState, action) => {
  switch (action.type) {
    case SET_SLOT_NAME:
      slot = state.slots.find(s => s.id === action.payload.id);
      if (slot) {
        slot.name = action.payload.name;
      }
      return {
        ...state,
        slots: [...state.slots]
      };

    case DELETE_SLOT:
      return {
        ...state,
        slots: sortSlotsByPosition(
          state.slots.filter(s => s.id !== action.payload.id)
        )
      };

    case REVERT_SLOT:
      slot = state.slots.find(s => s.id === action.payload.id);
      if (slot) {
        slot.revertData();
      }
      return {
        ...state,
        slots: [...state.slots]
      };

    case SET_GROUP_ORDER:
      slot = state.slots.find(s => s.id === action.payload.id);
      // TODO: ability to notify user to select a field first
      if (slot && slot.groupSettings) {
        slot.orderSettings = {
          field_name: slot.groupSettings,
          direction: action.payload.order
        };
      }
      return {
        ...state,
        slots: [...state.slots]
      };

    case SET_GROUP_COLUMN:
      slot = state.slots.find(s => s.id === action.payload.id);
      if (slot) {
        slot.groupSettings = action.payload.column;
        slot.orderSettings.field_name = action.payload.column;
      }
      return {
        ...state,
        slots: [...state.slots]
      };

    case SET_SUMMARY_COLUMN:
      slot = state.slots.find(s => s.id === action.payload.id);
      if (slot) {
        slot.summarySettings = action.payload.column;
        slot.orderSettings.field_name = action.payload.column;
      }
      return {
        ...state,
        slots: [...state.slots]
      };

    case SET_SUMMARY_ORDER:
      slot = state.slots.find(s => s.id === action.payload.id);
      // TODO: ability to notify user to select a field first
      if (slot && slot.summarySettings) {
        slot.orderSettings = {
          field_name: slot.summarySettings,
          direction: action.payload.order
        };
      }
      return {
        ...state,
        slots: [...state.slots]
      };

    case SET_DASHBOARD_NAME:
      return {
        ...state,
        title: action.payload.name
      };

    case COMMIT_DATA:
      const committedData = action.payload.data;
      return {
        ...state,
        slots: sortSlotsByPosition(
          committedData.slots.map(
            s =>
              new Slot({
                id: s.id,
                reportId: s.report_id,
                name: s.name,
                position: s.slot_position,
                updatedAt: s.updated_at,
                groupSettings: s.setup_properties.group_by,
                summarySettings: s.setup_properties.aggregation,
                orderSettings: s.setup_properties.order_by
              })
          )
        )
      };

    case REVERT_SLOTS:
      state.slots.forEach(s => s.revertData());
      return {
        ...state
      };

    case SET_DETAILS:
      const { dashboardDetails } = action.payload;
      return {
        ...state,
        title: dashboardDetails.name,
        slots: sortSlotsByPosition(
          dashboardDetails.slots.map(
            s =>
              new Slot({
                id: s.id,
                reportId: s.report_id,
                name: s.name,
                position: s.slot_position,
                updatedAt: s.updated_at,
                groupSettings: s.setup_properties.group_by,
                summarySettings: s.setup_properties.aggregation,
                orderSettings: s.setup_properties.order_by
              })
          )
        )
      };

    case RESET_DETAILS:
      return initialState;

    case ADD_REPORT_TO_ZONE:
      const slotsInTargetZone = state.slots.filter(
        s => s.position.x === action.payload.x
      );
      return {
        ...state,
        slots: [
          ...state.slots,
          new Slot({
            reportId: action.payload.reportId,
            name: '',
            position: {
              x: action.payload.x,
              y: slotsInTargetZone.length
            },
            groupSettings: null,
            summarySettings: null,
            orderSettings: {
              field_name: '',
              direction: 'desc'
            }
          })
        ]
      };

    case ADD_SLOT_TO_ZONE:
      slot = state.slots.find(s => s.id === action.payload.slotId);
      if (slot) {
        slot.position.x = action.payload.x;
        slot.position.y = state.slots.filter(
          s =>
            s.position.x === action.payload.x && s.id !== action.payload.slotId
        ).length;
        return {
          ...state,
          slots: sortSlotsByPosition(state.slots)
        };
      }
      return state;

    case SWAP_SLOT_WITH_REPORT:
      slot = state.slots.find(s => s.id === action.payload.dropId);
      dropIndex = _.findIndex(state.slots, ['id', action.payload.dropId]);
      if (!slot) return state;

      if (action.payload.direction === 'insertBefore') {
        state.slots.splice(
          dropIndex,
          0,
          new Slot({
            reportId: action.payload.dragId,
            name: '',
            position: {
              x: slot.position.x,
              y: slot.position.y
            },
            groupSettings: null,
            summarySettings: null,
            orderSettings: {
              field_name: '',
              direction: 'desc'
            }
          })
        );
      } else {
        state.slots.splice(
          dropIndex + 1,
          0,
          new Slot({
            reportId: action.payload.dragId,
            name: '',
            position: {
              x: slot.position.x,
              y: slot.position.y + 1
            },
            groupSettings: null,
            summarySettings: null,
            orderSettings: {
              field_name: '',
              direction: 'desc'
            }
          })
        );
      }
      return {
        ...state,
        slots: sortSlotsByPosition(state.slots)
      };

    case SWAP_SLOT_WITH_SLOT:
      // remove drag from the list
      const draggingSlot = state.slots.find(
        s => s.id === action.payload.dragId
      );
      if (!draggingSlot) return state;
      const slotAfterRemoval = state.slots.filter(
        s => s.id !== action.payload.dragId
      );

      // Insert back to proper position
      slot = slotAfterRemoval.find(s => s.id === action.payload.dropId);
      if (!slot) return state;

      dropIndex = _.findIndex(slotAfterRemoval, ['id', action.payload.dropId]);

      if (action.payload.direction === 'insertBefore') {
        draggingSlot.position.x = slot.position.x;
        draggingSlot.position.y = slot.position.y;
        slotAfterRemoval.splice(dropIndex, 0, draggingSlot);
      } else {
        draggingSlot.position.x = slot.position.x;
        draggingSlot.position.y = slot.position.y + 1;
        slotAfterRemoval.splice(dropIndex + 1, 0, draggingSlot);
      }
      return {
        ...state,
        slots: sortSlotsByPosition(slotAfterRemoval)
      };

    default:
      return state;
  }
};

export default details;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Details/flow/reducer.js